import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {onUpdated, ref, watch} from 'vue';
import {useSearchStore} from 'stores/search-store';
import {storeToRefs} from 'pinia';
import {useGrouperStore} from 'stores/grouper-store';
import {Services} from 'src/services/service-manager';
import { BookViewRecord, SearchService } from 'src/services/search-service';

export interface Props {
  records: Array<BookViewRecord>
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchResultDetailsContent',
  props: {
    records: { default: () => [] }
  },
  setup(__props: any) {

const opened = ref<Array<string>>([]);
const data = ref<Array<object>>([]);
const searchStore = useSearchStore();
const {searchResultDetails, resultItemRecord, bookId} = storeToRefs(searchStore);
const trucodeSearchService = Services.service(SearchService);
const minSeq = ref<number>();
const maxSeq = ref<number>();
const lastTimeStamp = ref<number>();

const props = __props;

function onSearch(result) {
  for (const resultElement of result) {
    data.value.push(resultElement);
  }
}

function parseNewResponse(newSearchResults) {
  data.value = [];
  opened.value = [];
  minSeq.value = resultItemRecord.value.data_sequence;
  maxSeq.value = resultItemRecord.value.data_sequence;
  if (newSearchResults && newSearchResults.length > 0) {
    parseResponse(newSearchResults, true);
  }
}

watch(searchResultDetails, (newSearchResults) => parseNewResponse(newSearchResults));

function scrollToHighlight() {
  if (!resultItemRecord.value) return;
  const xpath = "//div[text()='" + resultItemRecord.value?.text + "' and not(@class)]";
  const matchingElement = document.evaluate(xpath, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
  matchingElement?.scrollIntoView();
}

onUpdated(() => { scrollToHighlight(); })

function onScroll(event) {
  const el = event.target;

  // second part is hack for multiple scroll events to pass only one
  if ((el.scrollHeight - el.scrollTop - el.clientHeight < 1) && (!lastTimeStamp.value || (event.timeStamp - lastTimeStamp.value) > 50)) {
    lastTimeStamp.value = event.timeStamp;
    maxSeq.value = maxSeq.value + 50;
    trucodeSearchService.getCodebooksDetails(bookId.value + '_INDEX', maxSeq.value, useGrouperStore().patientEffectiveDate).then((resultDetails) => {
      parseResponse(resultDetails, true);
    });
  } else if (el.scrollTop === 0) {
    el.scrollTop = 1;
    minSeq.value = minSeq.value - 50;
    const resultDetails = trucodeSearchService.getCodebooksDetails(bookId.value + '_INDEX', minSeq.value, useGrouperStore().patientEffectiveDate).then((resultDetails) => {
      parseResponse(resultDetails, false);
    });
  }
}

function parseResponse(records: BookViewRecord[] | undefined, bottom: boolean) {
  for (const record of records) {
    if (record.record.type === 'letter' || record.record.full_path === null) continue;
    // Each full_path represents parent -> child path
    const terms = record.record.full_path.full.split(';');
    // Root of the tree, parent node here
    let object = data.value;
    for (const term of terms) {
      addTerm(object, term.trim(), bottom);
      // For each term we go deeper to place child in respective container
      // We need to perform search again cause of reactivity, we can't just return new array from call above
      object = findChildrenContainer(term.trim(), object);
    }
  }
}

function addTerm(where, term, bottom) {
  for (const object of where) {
    if (object.label === term) {
      return object.children;
    }
  }
  if (bottom) {
    where.push({label: term, children: []});
  } else {
    where.unshift({label: term, children: []});
  }
  opened.value.push(term);
}

function findChildrenContainer(term, where) {
  for (const object of where) {
    let found = recursiveSearch(term, object);
    if (found) return found;
  }
}

function recursiveSearch(term, where) {
  if (where.label === term) {
    return where.children;
  }
  for (const children of where.children) {
    let res = recursiveSearch(term, children);
    if (res) return res;
  }
}


return (_ctx: any,_cache: any) => {
  const _component_q_tree = _resolveComponent("q-tree")!

  return (_openBlock(), _createElementBlock("div", {
    id: "tree-holder",
    class: "iodine-scrollable-y browse-search",
    onScroll: onScroll
  }, [
    _createVNode(_component_q_tree, {
      nodes: data.value,
      "node-key": "label",
      "no-connectors": "",
      icon: "fa-solid fa-caret-right",
      class: "iodine-padding-left-lg",
      "default-expand-all": "",
      expanded: opened.value,
      "onUpdate:expanded": _cache[0] || (_cache[0] = ($event: any) => ((opened).value = $event))
    }, null, 8, ["nodes", "expanded"])
  ], 32))
}
}

})